<template>
  <div>
    <b-modal @hidden="$emit('close')" :id="'users-modal-' + id" no-close-on-esc hide-footer centered header-close-variant="dark" hide-backdrop cancel-title>
      <div class="modal-info" :style="users.length > 6 ? 'height: 400px' : ''">
        <div class="d-flex">
          <div class="header-title item number">#</div>
          <div class="header-title item">نام و نام خانوادگی کاربر</div>
          <div class="header-title item">تاریخ و ساعت ثبت نام کاربر</div>
        </div>
        <div v-for="(item, index) in users" :key="index" class="d-flex my-5">
          <div class="item">{{ index + 1 }}</div>
          <div class="item" v-if="typeof item.firstName === 'string'">{{ item.firstName + ' ' + item.lastName }}</div>
          <div v-else class="item">
            <hr class="line" />
          </div>
          <div class="item">{{ FormatedDate(item.createDate) }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import skillUpCourseProvider from '../../../services/skillUp/course'

export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      users: [],
    }
  },
  watch: {
    id() {
      this.fetchUsers()
    },
  },
  mounted() {
    this.fetchUsers()
  },

  methods: {
    async fetchUsers() {
      try {
        const req = await skillUpCourseProvider.getCourseUsers(this.id)
        this.users = req.data.data.output
      } catch (error) {
        console.log(error)
      }
    },
    convertDate(date) {
      // return FormatedDate(date)
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-info {
  overflow-y: auto;
}
.header-title {
  font-weight: bold;
  font-size: 14px;
}

.item {
  text-align: right;
  width: 33%;
  font-size: 13px;
  margin-left: 10px;
  &:first-of-type {
    padding-right: 30px;
  }
}

.number {
  width: 20% !important;
}

.line {
  margin: auto 0 !important;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  max-width: 50px;
}
</style>
